export class ExistingAccount extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setAttribute('aria-hidden', String(!this.accountExists))
  }

  get accountExists () {
    return (
      window.location?.search?.includes('return_url=%2Faccount') &&
      document.referrer.includes('/account/register')
    )
  }
}

if (!customElements.get('existing-account')) {
  customElements.define('existing-account', ExistingAccount)
}
